import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'sa-lmo-frac-home-coordinates',
  styleUrls: ['./lmo-frac-home-coordinates.component.scss'],
  templateUrl: './lmo-frac-home-coordinates.component.html',
})
export class LmoFracHomeCoordinatesComponent implements OnInit {
  @Input() public frac: any;
  @Input() public localStorageKey: string;
  @Input() public isLoading = false;

  constructor(private snackBar: MatSnackBar) {}

  public ngOnInit(): void {}

  public copyCoordinates(lat: number, lng: number): void {
    const coordinates = `${lat},${lng}`;

    navigator.clipboard
      .writeText(coordinates)
      .then(() => {
        this.snackBar.open('Copied to clipboard!', '', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      })
      .catch((err) => {
        console.error('Failed to copy direction: ', err);
        this.snackBar.open('Failed to copy to clipboard. Please try again.', '', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      });
  }
}
